(function () {
  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function parseCssLength(value, fallback) {
    if (!value) return fallback;
    var trimmed = String(value).trim();
    if (!trimmed) return fallback;
    if (trimmed.endsWith('vh')) {
      var vh = parseFloat(trimmed);
      return Number.isFinite(vh) ? (vh / 100) * (window.innerHeight || fallback) : fallback;
    }
    if (trimmed.endsWith('px')) {
      var px = parseFloat(trimmed);
      return Number.isFinite(px) ? px : fallback;
    }
    var num = parseFloat(trimmed);
    return Number.isFinite(num) ? num : fallback;
  }

  function scrollToStoryAnchor(id) {
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start',
    });
  }

  function bindStoryAnchors(root) {
    if (!root || root.dataset.jojoStoryAnchorBound === 'true') return;
    root.dataset.jojoStoryAnchorBound = 'true';

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-jojo-story-anchor]');
      if (!link || !root.contains(link)) return;

      var id = (link.getAttribute('data-jojo-story-anchor') || '').replace(/^#/, '').trim();
      if (!id || !document.getElementById(id)) return;

      event.preventDefault();
      scrollToStoryAnchor(id);
    });
  }

  function initJojoListingStory(root) {
    if (!root) return;
    bindStoryAnchors(root);
    if (root.dataset.jojoStoryReady === 'true') return;
    root.dataset.jojoStoryReady = 'true';

    var track = root.querySelector('[data-jojo-story-track]');
    var sticky = root.querySelector('[data-jojo-story-sticky]');
    var media = root.querySelector('.jojo-listing-story__media');
    var p1 = root.querySelector('[data-jojo-story-p="1"]');
    var p2 = root.querySelector('[data-jojo-story-p="2"]');
    var p3 = root.querySelector('[data-jojo-story-p="3"]');
    if (!track || !sticky || !media) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      root.style.setProperty('--jojo-story-pin-extra', 'auto');
      if (p1) p1.style.opacity = '0';
      if (p2) p2.style.opacity = '0';
      if (p3) p3.style.opacity = '0.9';
      return;
    }

    var ticking = false;
    var stickyTop = 85;
    var pinRoom = 1;

    function syncMetrics() {
      stickyTop = parseCssLength(getComputedStyle(sticky).top, 85);

      // Track = 2 × media height → pin scroll distance = 1 × media height
      var mediaHeight = media.offsetHeight || 0;
      pinRoom = Math.max(1, mediaHeight);
      root.style.setProperty('--jojo-story-pin-extra', mediaHeight * 2 + 'px');
    }

    function update() {
      ticking = false;
      var rect = track.getBoundingClientRect();
      var progress = clamp((stickyTop - rect.top) / pinRoom, 0, 1);

      // Hold → fade out ¶1+¶2 → only after fully out, fade in ¶3
      var outOpacity = 0.9;
      var inOpacity = 0;

      if (progress < 0.35) {
        outOpacity = 0.9;
        inOpacity = 0;
      } else if (progress < 0.7) {
        var outT = (progress - 0.35) / 0.35;
        outOpacity = 0.9 * (1 - outT);
        inOpacity = 0;
      } else {
        outOpacity = 0;
        var inT = (progress - 0.7) / 0.3;
        inOpacity = 0.9 * clamp(inT, 0, 1);
      }

      if (opacityReady(p1)) p1.style.opacity = String(outOpacity);
      if (opacityReady(p2)) p2.style.opacity = String(outOpacity);
      if (p3) p3.style.opacity = String(inOpacity);
    }

    function opacityReady(el) {
      if (!el) return false;
      var fading = el.classList.contains('jojo-fade-up') || el.classList.contains('jojo-fade-in');
      return !fading || el.classList.contains('is-settled');
    }

    function onScrollOrResize() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function () {
          syncMetrics();
          update();
        });
      }
    }

    syncMetrics();
    update();
    root.addEventListener('jojo:fade-settled', function () {
      syncMetrics();
      update();
    });
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(onScrollOrResize);
      ro.observe(media);
    }

    var imgs = media.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) {
        imgs[i].addEventListener('load', onScrollOrResize, { once: true });
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-jojo-listing-story]').forEach(initJojoListingStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-jojo-listing-story]');
    if (root) {
      root.dataset.jojoStoryReady = 'false';
      initJojoListingStory(root);
    }
  });
})();
